import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { guardRoundTrip } from '@mkp/shared/util-guards';
import { selectApplicationStatusesForSelectedAccount } from '@mkp/application/state';
import {
  applicationStatusApiActions,
  applicationStatusesGuardActions,
} from '@mkp/application/state/actions';
import { SnackbarService } from '@mkp/shared/util-snackbar';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, merge } from 'rxjs';

export const applicationStatusesExistGuard = () => {
  const store = inject(Store);
  const router = inject(Router);
  const actions$ = inject(Actions);
  const snackbarService = inject(SnackbarService);

  const showSnackbarAndRedirect = () => {
    snackbarService.showError('CANDIDATE_PAGE.COMMENT.ERROR');
    return router.parseUrl(AppConfig.routes.vacancies);
  };

  return guardRoundTrip({
    guardName: 'applicationStatusesExistGuard',
    dispatchRequest: () => store.dispatch(applicationStatusesGuardActions.canActivate()),
    outcome$: merge(
      store
        .select(selectApplicationStatusesForSelectedAccount)
        .pipe(filter((statuses) => !!statuses?.length)),
      actions$.pipe(ofType(applicationStatusApiActions.applicationStatusesLoadedSuccess)),
      actions$.pipe(
        ofType(applicationStatusApiActions.applicationStatusesLoadedFailure),
        map(() => showSnackbarAndRedirect())
      )
    ),
    onTimeout: showSnackbarAndRedirect,
  });
};
